var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"width":"400px"}},[_vm._v("Etkinlik henüz aktif değildir.")])
}
var staticRenderFns = []

export { render, staticRenderFns }